export enum MESSAGE_TYPE {
  SESSION = 'SESSION',
  NAVIGATION = 'NAVIGATION',
  ERROR = 'ERROR',
  NAVIGATION_CONFIRM = 'NAVIGATION_CONFIRM',
}
